import { dispatchEvent } from '@1inch-community/core/lit-utils';
export function selectToken(ctx, value) {
    dispatchEvent(ctx, 'selectToken', value);
}
export function changeExpand(ctx) {
    dispatchEvent(ctx, 'changeExpand', null);
}
export function changeExpandMore(ctx) {
    dispatchEvent(ctx, 'changeExpandMore', null);
}
export function favoriteToken(ctx, value) {
    dispatchEvent(ctx, 'favoriteToken', value);
}
export function changeSearchState(ctx, value) {
    dispatchEvent(ctx, 'changeSearchState', value);
}
//# sourceMappingURL=events.js.map